export default {"src":"/_next/static/media/icon_call.71f0bf43.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};